module.exports = __webpack_public_path__ + "static/media/marin.e90b465a.jpeg";